

export enum DependencyType {
    LINKED          = 1,
    FINISH_START    = 5,
    START_START     = 6,
    FINISH_FINISH   = 7,
    START_FINISH    = 8

}


// export type Dependency